/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { GetFormNameResponse } from '../model/getFormNameResponse';
import { SignFormRequest } from '../model/signFormRequest';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class FormsApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public downloadFormObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param submittingId 
* @param visitActionRequestId 
     */
    @action
    public downloadForm(submittingId: string, visitActionRequestId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {
        if (submittingId === null || submittingId === undefined) {
            throw new Error('Required parameter submittingId was null or undefined when calling downloadForm.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (visitActionRequestId !== undefined) {
            queryParameters['visitActionRequestId'] = visitActionRequestId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/forms/${encodeURIComponent(String(submittingId))}/download`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.downloadFormObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getFormNameObservable: GetFormNameResponse | undefined = undefined;

    /**
     * 
     * 
     * @param submittingId 
* @param visitActionRequestId 
     */
    @action
    public getFormName(submittingId: string, visitActionRequestId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<GetFormNameResponse> {
        if (submittingId === null || submittingId === undefined) {
            throw new Error('Required parameter submittingId was null or undefined when calling getFormName.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (visitActionRequestId !== undefined) {
            queryParameters['visitActionRequestId'] = visitActionRequestId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<GetFormNameResponse>(
            `${this.basePath}/api/forms/${encodeURIComponent(String(submittingId))}/name`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getFormNameObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public printFormObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param submittingId 
* @param visitActionRequestId 
     */
    @action
    public printForm(submittingId: string, visitActionRequestId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {
        if (submittingId === null || submittingId === undefined) {
            throw new Error('Required parameter submittingId was null or undefined when calling printForm.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (visitActionRequestId !== undefined) {
            queryParameters['visitActionRequestId'] = visitActionRequestId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/forms/${encodeURIComponent(String(submittingId))}/print`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.printFormObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public signObservable: any = undefined;

    /**
     * 
     * 
     * @param visitActionId 
* @param body 
     */
    @action
    public sign(visitActionId: string, body?: SignFormRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (visitActionId === null || visitActionId === undefined) {
            throw new Error('Required parameter visitActionId was null or undefined when calling sign.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<any>(
            `${this.basePath}/api/forms/${encodeURIComponent(String(visitActionId))}/sign`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.signObservable = response.data);
            }
            return response;
        });
    }

}
